import { NgIf } from '@angular/common';
import {
  Component,
  input,
  OnInit,
  signal,
} from '@angular/core';

import { DTO, Types } from 'shared-lib';
import {
  EComponentSize,
  EIcon,
  ELabelType,
  IComponentSection,
} from '../../types';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import {
  directive,
  LoadingService,
  ToastService,
} from '../../../public-api';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ui-user-registration',
  standalone: true,
  imports: [
    NgIf,
    DynamicFormComponent,
  ],
  templateUrl: './user-registration.component.html',
  styleUrl: './user-registration.component.scss',
})
@directive.Flowbite()
export class UserRegistrationComponent implements OnInit {
  fields = input<IComponentSection[]>([]);
  logo = input<string>('/images/logo_dark.png');
  loading = signal(true);

  ELabeltype = ELabelType;
  EComponentSize = EComponentSize;
  EIcon = EIcon;
  EInput = Types.EInput;
  EAlert = Types.EAlert;
  EList = Types.EList;
  currentFields = this.fields();

  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router,
    private loadingService: LoadingService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const personalInfo = {
      name: 'Informações Pessoais',
      selector: 'personal',
      content: [
        {
          component: 'TextComponent',
          selector: 'name',
          inputs: {
            placeHolder: 'Nome',
            default: '',
            value: '',
            type: Types.EInput.TEXT,
            required: true,
          },
        },
        {
          component: 'TextComponent',
          selector: 'lastName',
          inputs: {
            placeHolder: 'Sobrenome',
            default: '',
            value: '',
            type: Types.EInput.TEXT,
            required: true,
          },
        },
        {
          component: 'TextComponent',
          selector: 'document',
          inputs: {
            placeHolder: 'CPF',
            default: '',
            value: '',
            type: Types.EInput.CPF,
            required: true,
          },
        },
        {
          component: 'TextComponent',
          selector: 'phone',
          inputs: {
            placeHolder: 'Celular',
            default: '',
            value: '',
            type: Types.EInput.PHONE,
            required: true,
          },
        },
        {
          component: 'TextComponent',
          selector: 'email',
          inputs: {
            placeHolder: 'Email',
            default: '',
            value: '',
            type: Types.EInput.EMAIL,
            required: true,
          },
        },
        {
          component: 'TextComponent',
          selector: 'password',
          inputs: {
            placeHolder: 'Senha',
            default: '',
            value: '',
            type: Types.EInput.PASSWORD,
            required: true,
          },
        },
        {
          component: 'TextComponent',
          selector: 'birthDate',
          inputs: {
            placeHolder: 'Data de Nascimento',
            default: '',
            value: '',
            type: Types.EInput.DATE,
            required: true,
          },
        },
        {
          component: 'TrueComponent',
          selector: 'terms',
          inputs: {
            placeHolder: 'Eu li e concordo com os Termos e Condições de uso',
            default: false,
            value: '',
            required: false,
          },
        },
      ],
    };
    this.currentFields.unshift(personalInfo);
  }

  toLogin(){
    this.router.navigate(['/login']);
  }

  userRegister(event: any) {
    this.loadingService.start();
    const personalData = event['personal'];
    if (!personalData.terms){
      this.toastService.add(
        `Você precisa aceitar os termos e condições para prosseguir.`,
        30000,
        'danger'
      );
      return;
    }

    let userDTO = new DTO.UserDTO();
    userDTO.birthDate = personalData.birthDate;
    userDTO.name = personalData.name;
    userDTO.lastName = personalData.lastName;
    userDTO.document = personalData.document;
    userDTO.email = personalData.email;
    userDTO.password = personalData.password;
    userDTO.roles = [Types.ERole.USER];
    userDTO.phone = personalData.phone;

    this.http
      .post<DTO.UserDTO>('userAccount', userDTO)
      .pipe(
        map((response) => {
          this.toastService.add(
            `Cadastro concluído com êxito!`,
            30000,
            'success'
          );

          let loginDTO = new DTO.AuthInDTO();
          loginDTO.identifier = userDTO.email;
          loginDTO.password = userDTO.password ?? '';

          this.authService.login(loginDTO).subscribe((success) => {
            this.loadingService.stop();
            if (!success) {
              this.router.navigate(['/login']);
            }
          });

          return true;
        }),
        catchError((error) => {
          this.toastService.add(
            error.error.message ?? 'Ocorreu um erro ao cadastrar seus dados.',
            30000,
            'danger'
          );
          return of(false);
        })
      )
      .subscribe();

    this.loadingService.stop();
    this.loading.set(false);
  }
}
